import React from 'react';
import PlaybackRateControl from '../PlaybackRateControl';
import styles from './index.module.scss';

const WordsVideoControl = ({
  videoState,
  playButtonClick,
  previousButtonClick,
  previousButtonDisabled,
  nextButtonClick,
  nextButtonDisabled,
  repeatButtonClick,
  repeatDisabled,
  playbackRate,
  onChangePlaybackRate
}) => {
  return (
    <>
      <PlaybackRateControl
        onChange={onChangePlaybackRate}
        value={playbackRate}
      />
      <div className={styles.buttonGroup}>
        <button onClick={playButtonClick}>
          {videoState && videoState.isPlaying ? '暫停' : '播放'}
        </button>
        <button onClick={previousButtonClick} disabled={previousButtonDisabled}>
          上一筆
        </button>
        <button onClick={nextButtonClick} disabled={nextButtonDisabled}>
          下一筆
        </button>
        <button onClick={repeatButtonClick} disabled={repeatDisabled}>
          單筆重複
        </button>
      </div>
    </>
  );
};

export default WordsVideoControl;
